// import AssessorSummary from '../pages/assessor/details/summary'
import React, { lazy } from 'react'
import { Route, Routes } from 'react-router-dom'

// import TabularLoader from '../components/common/tabularLoader'
import { router_config } from '../configs/route.config'
import MyCompany from '../pages/company'
import Reports from '../pages/reports'
import ResetPassword from '../pages/userManagement/resetPasswords'
// import ResetPassword from '../pages/userManagement/resetpassword'
import ChildRoute from './components/childRoute'
// import ChildRoute from './components/childRoute'
import GuestRoute from './components/guestRoute'
import UserRoute from './components/userRoute'

// import { useAuthStore } from '../store/authStore'

const Login = lazy(() => import('../pages/userManagement/login'))
const ForgetPassword = lazy(
  () => import('../pages/userManagement/forgetPassword')
)
const ManagerUser = lazy(() => import('../pages/managers'))
const SwitchAccount = lazy(() => import('../pages/profile/switchAccount'))
const RequestAccess = lazy(
  () => import('../pages/profile/switchAccount/requestAccess')
)
const RequestedAccess = lazy(
  () => import('../pages/profile/switchAccount/requestedAccess')
)

const AdminUser = lazy(() => import('../pages/AdminUser'))
const AdminUserLog = lazy(() => import('../pages/users/log'))
const ReportFunds = lazy(() => import('../pages/reports/funds'))
const ReportJobs = lazy(() => import('../pages/reports/jobs'))
const ReportJobQueries = lazy(() => import('../pages/reports/jobQueries'))
const ReportLogs = lazy(() => import('../pages/reports/logs'))
const Notifications = lazy(() => import('../pages/notifications'))
// Dashboard

const Home = lazy(() => import('../pages/Home'))
const FileFolder = lazy(() => import('../pages/Funds/fileFolder'))

const Users = lazy(() => import('../pages/users'))
const Clients = lazy(() => import('../pages/clients'))
const ClientFunds = lazy(() => import('../pages/clients/fund'))

const Funds = lazy(() => import('../pages/Funds'))
const AllFunds = lazy(() => import('../pages/AllFunds'))

const Dashboard = lazy(() => import('../pages/dashboard/dashboard'))

const routes: any = [
  { slug: 'DASHBOARD', component: <Dashboard /> },

  {
    isAuthRoute: true,
    slug: 'LOGIN',
    component: <Login />,
    // from="admin"
  },
  {
    isAuthRoute: true,
    slug: 'USER_LOGIN',
    component: <Login />,
    //  from="user"
  },
  {
    isAuthRoute: true,
    slug: 'FORGET_PASSWORD',
    component: <ForgetPassword />,
  },
  {
    isAuthRoute: true,
    slug: 'ADMIN_FORGET_PASSWORD',
    component: <ForgetPassword />,
  },
  {
    isAuthRoute: true,
    slug: 'RESET_PASSWORD',
    component: <ResetPassword />,
  },
  // {
  //   slug: 'USER_PROFILE',
  //   component: <Profile />,
  // },

  { slug: 'ADMIN_USER', component: <AdminUser /> },
  { slug: 'MANAGER_USERS', component: <ManagerUser /> },
  { slug: 'MY_COMPANY', component: <MyCompany /> },
  { slug: 'REPORTS', component: <Reports /> },
  { slug: 'NOTIFICATIONS', component: <Notifications /> },
  { slug: 'ADMIN_USER_LOG', component: <AdminUserLog /> },
  { slug: 'USERS', component: <Users /> },
  { slug: 'CLIENTS', component: <Clients /> },
  { slug: 'CLIENT_VIEW', component: <ClientFunds /> },
  { slug: 'HOME', component: <Home /> },
  { slug: 'FILE_FOLDER', component: <FileFolder /> },
  { slug: 'ADMIN_FILE_FOLDER', component: <FileFolder /> },
  { slug: 'FUNDS', component: <Funds /> },
  { slug: 'ALL_FUNDS', component: <AllFunds /> },
  { slug: 'REPORT_FUNDS', component: <ReportFunds /> },
  { slug: 'REPORT_JOBS', component: <ReportJobs /> },
  { slug: 'REPORT_JOB_QUERIES', component: <ReportJobQueries /> },
  { slug: 'REPORT_LOGS', component: <ReportLogs /> },
  {
    slug: 'SWITCH_ACCOUNT',
    component: <SwitchAccount />,
    children: [
      { slug: 'REQUEST_ACCESS', component: <RequestAccess /> },
      { slug: 'REQUESTED_ACCESS', component: <RequestedAccess /> },
    ],
  },
]

export default function MainRoutes() {
  // const {
  //   is_admin,
  // } = useAuthStore()?.userData
  return (
    <Routes>
      {routes.map((route: any) => (
        <React.Fragment key={route.slug}>
          {route.isAuthRoute ? (
            <Route
              element={<GuestRoute>{route.component}</GuestRoute>}
              path={router_config[route.slug]?.path}
              key={router_config[route.slug]?.path}
            />
          ) : (
            <Route
              element={
                <UserRoute slug_key={route.slug}>{route.component}</UserRoute>
              }
              path={router_config[route.slug]?.path}
              key={router_config[route.slug]?.path}
            >
              {route.children?.length && (
                <>
                  {route.children.map((child: any) => (
                    <Route
                      element={
                        <ChildRoute slug_key={child.slug}>
                          {child.component}
                        </ChildRoute>
                      }
                      path={router_config[child.slug]?.path}
                      key={router_config[child.slug]?.path}
                    />
                  ))}
                </>
              )}
            </Route>
          )}
        </React.Fragment>
      ))}

      <Route
        element={
          //           <UserRoute slug_key="">
          // <Dashboard />
          // </UserRoute>

          <GuestRoute>
            <Login />
            {/* {
              is_admin ?  <Dashboard /> : <Login/>
          } */}
          </GuestRoute>
        }
        key="*"
        path="*"
      />
    </Routes>
  )
}
